import { SubmissionError } from 'redux-form';
import { updateReturnVoucher } from '../vouchersActions';

const submit = (values, dispatch, props) => {
  const errors = {};
  if (values.items) {
    values.items.forEach((item, itemIndex) => {
      const itemErrors = {
        desiredItem: {}
      };
      const itemsArrayErrors = [];
      if (
        (!item || (item.desiredItem && !item.desiredItem.ean13)) &&
        item.returnNatureCode === 'exchange'
      ) {
        itemErrors.desiredItem.ean13 = 'Champs requis';
        itemsArrayErrors[itemIndex] = itemErrors;
      }
      if (itemsArrayErrors.length) {
        errors.items = itemsArrayErrors;
        throw new SubmissionError(errors);
      }
    });
  }
  dispatch(
    updateReturnVoucher({
      ...values,
      returnVoucherId: props.currentReturnVoucher.id
    })
  );
};

export default submit;
